<template>
  <div class="v-d-gift">
    <img class="deco-img flag-deco" src="@/assets/img/index/deco_flag_2.png" />

    <div class="g-content v-d-gift__content">
      <section-title title="贈禮" />

      <!-- <div class="article-wrap mobile-show">
        <carousel :carouselList="giftBoxList" />
      </div> -->

      <div class="article-wrap">
        <ul class="article-list" :style="{ transform: `translateX(-${(currIndex * 100) / giftBoxList.length}%)` }">
          <li class="article-list__item" v-for="d of giftBoxList" :key="d.id">
            <gift-box :data="{ ...d.data, imgPath: d.imgPath }" />
          </li>
        </ul>
      </div>

      <div class="dots">
        <div class="dots__circle" :class="{ 'dots__circle--active': idx === currIndex }" v-for="idx of dotList" :key="idx"
          @click="handleDotIndex(idx)"></div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  defineComponent, ref, shallowRef, watch,
} from 'vue';
import { v4 as uuid } from 'uuid';
import useRequest from '@/hooks/useRequest';
import { getViewArticlesAPI } from '@/api/articles';
import GiftBox from '@/components/Home/GiftBox.vue';
import previewImg from '@/assets/img/global/img_preview.jpg';
// import mediaImg8 from '@/assets/img/index/img_8.png';
// import mediaImg9 from '@/assets/img/index/img_9.png';
// import Carousel from '@/components/Global/Carousel.vue';

export default defineComponent({
  name: 'Media',
  components: {
    GiftBox,
    // Carousel,
  },
  setup() {
    const currIndex = ref(0);
    const dotList = [0, 1];
    const handleDotIndex = (idx) => {
      currIndex.value = idx;
    };
    const giftBoxList = ref([]);
    const { response, request, isLoading } = useRequest(getViewArticlesAPI);

    request({
      page: 1,
      limit: 2,
      type: 'gift',
    });

    const getViewArticles = async (res) => {
      const {
        result: { data },
        status,
      } = res.value;
      // console.log(res.value);

      if (status) {
        const baseUrl = process.env.VUE_APP_BASE_URL;

        giftBoxList.value = data.map((item) => {
          const coverImageSrc = item.cover_path ? `${baseUrl}${item.cover_path}` : previewImg;

          return {
            data: {
              title: item.title,
              desc: item.description,
              id: item.uuid,
              type: item.type,
              published: item.published,
            },
            id: uuid(),
            renderContent: shallowRef(GiftBox),
            imgPath: coverImageSrc,
          };
        });
      }
    };

    watch(response, () => {
      getViewArticles(response);
    });

    // const mediaBoxList = [
    //   {
    //     id: uuid(),
    //     data: {

    //       title: '早產兒禮袋-圓緣袋',
    //       desc: '12月好禮，請來電洽詢。',

    //     },
    //     imgPath: mediaImg8,
    //     renderContent: GiftBox,
    //   },
    //   {
    //     id: uuid(),
    //     data: {

    //       title: '早產兒禮袋-圓緣袋',
    //       desc: '12月好禮，請來電洽詢。',

    //     },
    //     imgPath: mediaImg9,
    //     renderContent: GiftBox,
    //   },
    // ];

    return {
      giftBoxList,
      dotList,
      currIndex,
      handleDotIndex,
      isLoading,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '~@/styles/share/home.scss';
@import '~@/styles/utils/_rwd.scss';

.v-d-gift {
  position: relative;

  &__content.g-content {
    padding-top: 50px;
    padding-bottom: 50px;
  }
}

.flag-deco {

  @include position(tl, -20px, -20px);
}

.article-wrap {
  width: 100%;
  overflow: hidden;
  width: 100%;
}

.article-list {
  @include flex(flex-start, center, column);
  width: 100%;
  transition: 0.4s;

  &__item {
    width: 100%;

    &+& {
      margin-top: 50px;
    }
  }
}

.tablet-show {
  display: none;
}

@media screen and (min-width: $tablet) {
  .article-wrap {}

  .article-list {
    @include flex(flex-start, flex-start);
    width: auto;
    transition: 0.4s;
    margin: 0 -35px;

    &__item {
      flex: none;
      width: 50%;
      @include padding(0 35px);

      &+& {
        margin-top: 0px;
      }
    }
  }

  .mobile-show {
    display: none;
  }

  .tablet-show {
    display: block;
  }
}

@media screen and (min-width: $pc) {
  .v-d-gift {

    &__content.g-content {
      @include padding(180px 0 120px);
    }
  }

}

@media screen and (min-width: $lg-pc) {}
</style>
